<template>
	<div v-if="client" class="md-layout md-gutter">
        <div class="md-layout-item md-size-50">
            <user-profile-card :user="client"/>
        </div>
        <div class="md-layout-item md-size-50">
            <user-password-card :user="client"/>
        </div>
	</div>
</template>

<script>
// Components
import UserProfileCard from "@/components/ClientsArea/Profile/ProfileCard";
import UserPasswordCard from "@/components/ClientsArea/Profile/EditPasswordCard"

// Vuex
import { mapState } from "vuex";

export default {
	name: "ClientsAreaProfile",
	components: {
		UserProfileCard,
		UserPasswordCard
	},
	computed: mapState({
        client: state => state.caAuth.client,
	}),
}
</script>
